import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {LazyLoadImage} from "react-lazy-load-image-component";
import Logo from "../../images/location_new/singlecase/Mocuts-Logo.webp";
import CaseImg from "../../images/location_new/singlecase/MoCuts.webp";
import {Case_Arrow} from "../../../app-constants";
import {Link} from 'gatsby';

function Singleproject(props) {
    const gradientStyle = {
        background: 'linear-gradient(90deg, #fff3f2 70%, rgb(255, 255, 255) 70%)',
      };
      const ColorStyle = {
        color: '#78332a',
      };
      const textAndBackgroundColor = {
        backgroundColor: '#78332a',
    
      };
    return (
        <div className="singleproject p-100" style={gradientStyle}>
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="img_logo">
                            <LazyLoadImage
                                src={Logo}
                                effect="blur" alt="LogoNext" className="img-fluid"
                            />
                        </div>
                        <div className="example" data-text="Feature">
                            <h2 style={ColorStyle}> Where Quality Meets Convenience</h2>
                        </div>
                        <p style={ColorStyle}> Your go-to online hub for booking skilled barbers, beauticians, and a variety of everyday barber services with ease and convenience.</p>
                        <Link to={`/case-studies/mocuts`} className="case_btn"
                               aria-label="TekRevol Contact" style={textAndBackgroundColor}>
                            View Case Study {Case_Arrow}
                        </Link>

                    </Col>
                    <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="technology_list">
                            <div className="tech_name">iOS App</div>
                            <div className="tech_name">Android App</div>
                            <div className="tech_name">UI UX Design</div>
                        </div>
                        <div className="mx-img">
                            <LazyLoadImage
                                src={CaseImg}
                                effect="blur" alt="NXGrad" className="img-fluid"
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Singleproject;